<div class="main-sub-banner">
  <ngx-slick-carousel class="carousel offer-slider desktop" #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let slide of slides;let i=index" class="slide">
      <a (click)="redirectTo(slide)" href='javascript:void(0);'>
        <img [src]="statePersist.getSafeUrl(slide.web_image_url)" alt="" width="100%">
      </a>
    </div>
  </ngx-slick-carousel>

  <ngx-slick-carousel class="carousel offer-slider mobile " #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let slide of slidesMobile;let i=index" class="slide">
      <a (click)="redirectTo(slide)" href='javascript:void(0);'>
        <img [src]="statePersist.getSafeUrl(slide.mob_image_url)" alt="" width="100%">
      </a>
    </div>
  </ngx-slick-carousel>
</div>